import cn from 'classnames';
import React, { PropsWithChildren } from 'react';

import { useAuthCache } from 'api/cache';
import Footer from 'components/organisms/footer';
import Header from 'components/organisms/header';

import sm from './styles.module.scss';

const Authenticated = ({ children }: PropsWithChildren<{}>) => {
  'use memo';

  const { loggedIn } = useAuthCache();

  return (
    <div className={sm.Container}>
      {loggedIn && <Header />}
      <div className={cn(sm.Container_Body, 'bounds-container')}>
        {children}
      </div>
      {loggedIn && <Footer />}
    </div>
  );
  // endregion
};

export default Authenticated;
